'use strict';

var isString = require('./isString-d8679d99.js');

function takeWhile(p, as) {
  var s = isString.isString(as) ? '' : [];
  var n = as.length;

  for (var i = 0; i < n && p(as[i]); i++) {
    s = s.concat(as[i]);
  }

  return s;
}

module.exports = takeWhile;
